import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app">
      <div className="container">
        <header className="header">
          <div className="logo-container">
            <h1 className="logo-text">Laikly LLC</h1>
          </div>
        </header>

        <main className="main">
          <div className="hero-section">
            <h2 className="hero-title">Building Tomorrow's Solutions</h2>
            <p className="hero-subtitle">
              We create innovative products that make a meaningful impact in people's lives through thoughtful design and cutting-edge technology.
            </p>
          </div>

          <div className="portfolio-section">
            <h3 className="section-header">Our Portfolio</h3>
            
            <a href="https://cheffedapp.com" target="_blank" rel="noopener noreferrer" className="portfolio-card">
              <div className="portfolio-icon">👨‍🍳</div>
              <div className="portfolio-content">
                <h4 className="portfolio-title">Cheffed</h4>
                <p className="portfolio-description">
                  AI-powered recipe discovery and meal planning app that helps you cook delicious meals tailored to your preferences.
                </p>
                <div className="portfolio-link">
                  Visit CheffedApp.com →
                </div>
              </div>
            </a>
          </div>

          <div className="contact-section">
            <h3 className="section-header">Get in Touch</h3>
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <div className="contact-content">
                <p className="contact-text">
                  Interested in learning more about what we're building? We'd love to hear from you.
                </p>
                <a href="mailto:brian@itslaikly.com" className="contact-email">
                  brian@itslaikly.com
                </a>
              </div>
            </div>
          </div>
        </main>

        <footer className="footer">
          <p>&copy; 2025 Laikly LLC. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
